import { ApiProperty } from "@nestjs/swagger";
import { IsOptional, MaxLength, Matches } from "class-validator";
import { AssetServiceChecklistDto } from "./asset-service-checklist.dto";
import { ServiceStatusEnum } from "@gtpl/shared-models/common-models";

export class AssetServiceDto {
    @ApiProperty()
    assetServeId: number;

    @ApiProperty()
    assetId: number;

    @ApiProperty()
    assetName: number;

    @ApiProperty()
    assetCode: string;

    @ApiProperty()
    assetCategory: string;

    @ApiProperty()
    serviceTenure: number;

    @ApiProperty()
    dateOfPurchased: Date;

    @ApiProperty()
    assetServiceDate: Date;

    @ApiProperty()
    actAssetServiceDate: Date;

    @ApiProperty()
    isActive: boolean;

    CreatedAt: Date;

    @ApiProperty()
    status: ServiceStatusEnum;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: 'updated User allows maximum 40 charecters' })
    @Matches(new RegExp(""))
    createdUser: string;

    updatedAt: Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: 'Updated User allows maximum 40 characters' })
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), { message: 'Updated User should be only alphabets' })
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    frequencyOfService: string;
    @ApiProperty()
    month: string;
    @ApiProperty()
    day: string;
    @ApiProperty()
    serviceProvider: string
    @ApiProperty()
    assetServiceChecklist: AssetServiceChecklistDto[]
    @ApiProperty()
    assetCategoryId: any;
    @ApiProperty()
    serviceName: string;
    @ApiProperty()
    remarks: string;
    @ApiProperty()
    serviceOwner:string;
    @ApiProperty()
    phoneNumber:string;
    @ApiProperty()
    serviceType:string;
    startDate:string;
    endDate:string;

}